import jquery from 'jquery';
import 'jquery.transit';
import 'jquery-easing';
import 'es6-promise/auto';

window.$ = jquery;
window.jQuery = jquery;

import owd from 'owd/owd';
import 'app/components/img-load';
import 'app/components/video';
import 'app/components/form';
import 'app/components/slider';
import 'app/components/scroll-top';
import 'app/components/menu-toggle';
import 'app/components/nav-toggle';
import 'app/components/inview';
import 'app/components/pagination';
import 'app/components/select';
import 'app/components/fields';
import 'app/components/member';
import 'app/components/portfolio-filter';
import 'app/components/header';
import 'app/components/vimeo-player';
import 'app/components/autoplay';
import 'app/components/fix-100vh';

import DefaultResolver from 'app/ajax/default-resolver';
import PortfolioResolver from 'app/ajax/portfolio-resolver';
import LangResolver from 'app/ajax/lang-resolver';

import Ajax from 'owd/module/ajax';
import ScrollTo from 'owd/module/scroll-to';
import BrowserCheck from 'owd/module/browser-check';

const app = new owd.App();

app.use('scrollTo', ScrollTo);
app.use('browserCheck', BrowserCheck);


app.use('ajax', Ajax)
    .registerDefaultResolver(DefaultResolver)
    .registerResolver('portfolio', PortfolioResolver)
    .registerResolver('lang', LangResolver);

app.run();
